const trains = {
  train: "Traukinys", // translated 
  trains: "Traukiniai", // translated 
  fairConditions: "Sąžiningos sąlygos", // translated 
  to: "į", // translated 
  earlier: "Anksčiau", // translated 
  later: "Vėliau", // translated 
  adults: "Suaugusieji", // translated 
  child: "Vaikas", // translated 
  senior: "Vyresnysis", // translated 
  seniors: "Senjorai", // translated 
  price: "Kaina", // translated 
  for: "dėl", // translated 
  total: "Iš viso", // translated 
  selected: "Pasirinkta", // translated 
  prebook: "Išankstinė knyga", // translated 
  book: "Knyga", // translated 
  payment: "Mokėjimas", // translated 
  return: "Grįžti", // translated 
  passengers: "Keleiviai", // translated 
  delivery: "Pristatymas", // translated 
  summary: "Santrauka", // translated 
  checkout: "Patikra", // translated 
  trainToastCorrectFillForm: "Prašome tinkamai užpildyti visus laukus.", // translated 
  fareConditions: "Bilietų kainos sąlygos", // translated 
  travelInfo: "Informacija apie keliones", // translated 
  remarks: "Klientų pastabos", // translated 
  noServices: "Jokių paslaugų", // translated 
  timesAndSeats: "Laikai ir vietos", // translated 
  mobileTicket: "Mobilus bilietas", // translated 
  stationTicket: "Surinkite stotyje", // translated 
  homeTicket: "Spausdinti namuose", // translated 
  countryCode: "Šalies kodas", // translated 
  chooseTicket: "Pasirinkite bilietų pristatymo būdą", // translated 
  ticketError: "Pasirinkite bilietą į visas vietas", // translated 
  ticketDelivery: "Pasirinkite bilieto pristatymo būdą", // translated 
  passengerDetails: "Informacija apie keleivius", // translated 
  waitWhileProcessingPayment:
    "Palaukite, kol apdorosime jūsų mokėjimą, neatnaujinkite ir neuždarykite puslapio.", // translated 
  reductionCardId: "Sumažinimo kortelės ID", // translated 
  countryOfResidence: "Gyvenamoji šalis", // translated 
  countryOfBirth: "Gimimo šalis", // translated 
  documentCountry: "Dokumento šalis", // translated 
  documentNumber: "Dokumento numeris", // translated 
  expirationDate: "Galiojimo laikas", // translated 
  documentType: "Dokumento tipas", // translated 
  travelerDocumentInfo: "Informacija apie keliautojo dokumentus", // translated 
  youth: "Jaunimas", // translated 
  youths: "Jaunuoliai", // translated 
  departTimeEarlyFirst: "Išvykimo laikas (pirmiausia anksčiausiai)", // translated 
};



export default trains;
